var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 18.074a.822.822 0 0 0-.252-.571L7.063 9.908l7.595-7.595a.815.815 0 0 0-.263-1.342.815.815 0 0 0-.893.186L5.33 9.33a.817.817 0 0 0 0 1.156l8.173 8.172a.819.819 0 0 0 1.408-.584z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCaretLeft);
export default __webpack_public_path__ + "static/media/big-caret-left.e4eca5562aec990a8a730485e1f92df4.svg";
export { ForwardRef as ReactComponent };